import { EGarageType } from '../../../../api-models/common/json_query';

export const GARAGE_TYPES_MAP_VALUE_TO_LABEL = {
  [EGarageType.Any]: '',
  [EGarageType.Garage]: 'Гараж',
  [EGarageType.CarPlace]: 'Машиноместо',
  [EGarageType.Box]: 'Бокс',
};
